import axios from 'axios';
import {extractData, handleApiException, handleResponse} from '../helpers/apiResponseHelper';
import {CustomerLocation} from '../models/customer-location';
import {apiService} from './api.service';

async function getCustomerLocations(customerId: number): Promise<CustomerLocation[]> {
    return axios.get(`${apiService.getApiUrl()}/customer-locations/customer/${customerId}`)
      .then(handleResponse).then(extractData).catch(error => handleApiException(error));
}

export const CustomerLocationService = {
    getCustomerLocations
};
